import { render, staticRenderFns } from "./DlgAdvisorDelete.vue?vue&type=template&id=5947518f&scoped=true"
import script from "./DlgAdvisorDelete.vue?vue&type=script&lang=ts"
export * from "./DlgAdvisorDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5947518f",
  null
  
)

export default component.exports